<template>
  <div id="dashboard-wrapper">
    <div class="col-md-12">
      <h1>Welcome to Daisy.</h1>
      <h4>Daisy is an easy way to build offers and daisy chain them together in sets.</h4>
      <div class="contentSection">
        <div class="row">
          <div class="col-md-6 text-center">
            <div class="singleSquare mt-2"></div>
            <router-link to="/offers/create" class="blueBtn mb-3">Create an Offer</router-link>
            <p>Offers can be added together in a midpath set.</p>
          </div>
          <div class="col-md-6 text-center">
            <div style="margin:0 auto; width:210px;">
              <div class="multiSquare mt-2"></div>
              <div class="multiSquare mt-2"></div>
              <div class="multiSquare mt-2"></div>
            </div>
            <router-link to="/sets/create" class="blueBtn mb-3">Create a Set</router-link>
            <p>A set is a midpath flow made up of offers.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  mounted () { },
  methods: {},
  computed: {},
  components: {}
}
</script>
<style lang="scss" scoped>
#dashboard-wrapper {
  p {
    padding: 0px;
    margin: 0px;
  }
}
</style>
